import { render, staticRenderFns } from "./TokenManagementAutoSellTokenBotInfo.vue?vue&type=template&id=ce88f5d2&scoped=true&lang=pug"
import script from "./TokenManagementAutoSellTokenBotInfo.vue?vue&type=script&lang=ts"
export * from "./TokenManagementAutoSellTokenBotInfo.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementAutoSellTokenBotInfo.vue?vue&type=style&index=0&id=ce88f5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce88f5d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VSpacer,VSwitch})
